import Confetti from "react-confetti";
import {
  updateGlobalContext,
  useGlobalContext,
} from "../context/GlobalContext";
import { useEffect, useState } from "react";

export const ConfettiView = () => {
  const { confetti } = useGlobalContext();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (confetti) {
      setShow(true); // burst

      // stop emitting almost immediately so the burst is visible & snappy
      setTimeout(() => {
        setShow(false);
      }, 1200);

      // clear confetti from screen entirely shortly after pieces fall
      setTimeout(() => {
        updateGlobalContext({ confetti: false });
      }, 3000);
    }
  }, [confetti]);
  return (
    confetti && (
      <Confetti
        numberOfPieces={show ? 500 : 0}
        recycle={false}
        gravity={0.5}
        initialVelocityY={25}
        initialVelocityX={10}
        tweenDuration={2000}
      />
    )
  );
};

export const showConfetti = () => {
  // activate confetti flow
  updateGlobalContext({ confetti: true });
};
